module.exports = __webpack_public_path__ + "static/pn-1fdeed04cbaa0c72116fb7867af2f6b1.svg";